import { escapeRegExp } from "@synthesis/shared-utils";
//#region src/Select/Select.lib.ts
const itemInSearch = (regexp, item) => {
	if (Array.isArray(item.label)) return item.label.some((labelChunk) => {
		const isMatch = typeof labelChunk === "string" ? regexp.test(labelChunk) : regexp.test(labelChunk.label);
		regexp.lastIndex = 0;
		return isMatch;
	});
	const isMatch = regexp.test(item.label);
	regexp.lastIndex = 0;
	return isMatch;
};
const filterItems = (search, items) => {
	const regex = new RegExp(escapeRegExp(search), "ig");
	return items?.filter((item) => itemInSearch(regex, item));
};
const filterGroups = (search, groups) => {
	const regex = new RegExp(escapeRegExp(search), "ig");
	return groups?.reduce((acc, group) => {
		const filteredItems = group.items.filter((item) => itemInSearch(regex, item));
		if (filteredItems.length > 0) acc.push({
			...group,
			items: filteredItems
		});
		return acc;
	}, []);
};
const isGroupItems = (items) => Boolean(items && Object.hasOwn(items?.[0] || {}, "items"));
const selectItemsToDict = (itemsOrGroups) => {
	if (isGroupItems(itemsOrGroups)) return itemsOrGroups.reduce((acc, group) => {
		group.items.forEach(({ value, label }) => {
			if (Array.isArray(label)) {
				const first = label[0];
				acc[value] = typeof first === "string" ? first : first?.label ?? "";
			} else acc[value] = label;
		});
		return acc;
	}, {});
	return itemsOrGroups.reduce((acc, { value, label }) => {
		if (Array.isArray(label)) {
			const first = label[0];
			acc[value] = typeof first === "string" ? first : first?.label ?? "";
		} else acc[value] = label;
		return acc;
	}, {});
};
const selectItemDisplayLabel = (item) => {
	const { label } = item;
	if (typeof label === "string") return label;
	const first = label[0];
	if (!first) return "";
	return typeof first === "string" ? first : first.label;
};
const findItemByValue = (items, val) => {
	if (isGroupItems(items)) for (const group of items) {
		const found = group.items.find((item) => item.value === val);
		if (found) return found;
	}
	else return items.find((item) => item.value === val);
};
/** Как `IconStyles` в Input: компактные размеры — меньше иконка (стрелка и слот слева). */
function selectTriggerChevronClassName(size) {
	return size === "xs" || size === "sm" ? "size-5" : "size-6";
}
/** Tailwind-селектор размера для дочернего svg в `iconLeft` триггера. */
function selectTriggerLeftIconChildClassName(size) {
	return size === "xs" || size === "sm" ? "[&>*]:size-5" : "[&>*]:size-6";
}
//#endregion
export { filterGroups, filterItems, findItemByValue, isGroupItems, itemInSearch, selectItemDisplayLabel, selectItemsToDict, selectTriggerChevronClassName, selectTriggerLeftIconChildClassName };

//# sourceMappingURL=Select.lib.js.map